module.exports = __webpack_public_path__ + "img/celtic.acc21cd9.jpg";